import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children, requireAdmin = false, requireProvider = false }) => {
  const { isAuthenticated, loading, isAdmin, isProvider, userProfile } = useAuth();

  // Debug logging
  if (requireAdmin) {
    console.log('🔐 Admin Check:', {
      requireAdmin,
      isAdmin,
      userProfile: {
        role: userProfile?.role,
        isAdmin: userProfile?.isAdmin,
        email: userProfile?.email
      },
      willBlock: requireAdmin && !isAdmin
    });
  }

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin) {
    console.error('❌ Admin access denied. Redirecting to dashboard.');
    return <Navigate to="/dashboard" replace />;
  }

  if (requireProvider && !isProvider && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;